const VIEW_PATHS = {
  HOME: '/host',
  PROMO: '/host/stock-promo',
  PRESENCE_CONTENT: '/host/presence-content',
};

const getSelectedView = (path) => {
  return {
    isHomeActive: path === VIEW_PATHS.HOME,
    isPromoActive: path === VIEW_PATHS.PROMO,
    isPresenceContentActive: path === VIEW_PATHS.PRESENCE_CONTENT,
  };
};

export default getSelectedView;
